<!-- <div class="absolute">
	<a (click)="onChangeLanguage('en')" class="pointer">en</a> |
	<a (click)="onChangeLanguage('it')" class="pointer">it</a> |
	<a (click)="onChangeLanguage('es')" class="pointer">es</a> |
	<a (click)="onChangeLanguage('de')" class="pointer">de</a> |
	<a (click)="onChangeLanguage('fr')" class="pointer">fr</a> |
	<a (click)="onChangeLanguage('nl')" class="pointer">nl</a>
</div> -->
<router-outlet></router-outlet>
